import React from "react"

const Circles = ({
  bgUrl = "",
  headerText = "",
  headerFont = "Arial",
  headerFontColor,
  logoUrl = "",
  headerType,
  headerColor,
  menuItems = [],
  buttonText = "",
  buttonColor,
  buttonTextColor,
  menuTabColor,
  menuTextColor,
  menuFont = "Arial",
}) => {
  const menuItem = menuItems.slice(0, 9).map(item => (
    <div
      style={{
        fontSize: "0.7em",
        width: "80px",
        height: "70px",
        margin: "3px",
        marginTop: "30px",
        textAlign: "-webkit-center",
        backgroundColor: menuTabColor,
      }}
      key={item?.id}
    >
      <div
        style={{
          background: item?.image ? `url("${item?.image?.url}")` : menuTabColor,
          width: "60px",
          height: "60px",
          backgroundSize: "cover",
          borderRadius: "50%",
          transform: "translate(0px, -20px)",
          border: "1px solid white",
          backgroundPosition: "center",
        }}
      ></div>
      <span
        style={{
          color: menuTextColor,
          fontFamily: menuFont,
          fontWeight: "bold",
          transform: "translate(0px, -15px)",
          display: "inline-block",
        }}
      >
        {item?.label}
      </span>
    </div>
  ))

  return (
    <div
      style={{
        backgroundImage: `url(${bgUrl})`,
        width: "105%",
        height: "105%",
        backgroundSize: "cover",
        marginLeft: "-5px",
        backgroundPosition: "center center",
        textAlign: "center",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "70px",
          borderRadius: "0% 0% 40% 40%",
          backgroundColor: headerType === "2" ? headerColor : "transparent",
          textAlign: "center",
        }}
      >
        {headerText && (
          <p
            style={{
              fontSize: "25px",
              textAlign: "center",
              paddingBlockStart: "1em",
              color: headerFontColor,
              fontFamily: headerFont,
            }}
          >
            {headerText}
          </p>
        )}
        {logoUrl && (
          <img
            src={logoUrl}
            style={{
              blockSize: "auto",
              maxWidth: "80%",
              maxHeight: "90%",
              paddingBlockStart: "1em",
            }}
          />
        )}
      </div>
      <span
        style={{
          color: buttonTextColor,
          fontFamily: menuFont,
          textTransform: "uppercase",
          fontSize: "1em",
          padding: "5px",
          width: "85%",
          height: "30px",
          borderRadius: "5px",
          textAlign: "center",
          backgroundColor: buttonColor,
          marginTop: "10px",
          display: "inline-block",
        }}
      >
        {buttonText}
      </span>
      <div
        style={{
          paddingTop: "10px",
          flexWrap: "wrap",
          flexDirection: "row",
          justifyContent: "space-evenly",
          display: "flex",
          marginBottom: "10px",
        }}
      >
        {menuItem}
      </div>
    </div>
  )
}

export default Circles
